import { PageShell } from '@/components/content/ContentBits';
import StackSections from '@/content/StackSections';

const StackPage = () => (
  <PageShell
    eyebrow="Take it home"
    title="The Sustainable Stack"
    subtitle="What you keep after today, what it costs (almost nothing), and how to unlock the rest of the nonprofit internet."
    testId="stack-page"
  >
    <StackSections />
  </PageShell>
);

export default StackPage;
